import { useMutation } from "@apollo/react-hooks";
import { Button, Checkbox } from "components/common";
import {
  LegalLink,
  LEGAL_LINK_TYPES,
  LEGAL_LINK_CONFIG,
} from "components/common/LegalLink";
import React, { useState } from "react";
import { SUBMIT_CARDHOLDER_TERMS_QUERY, GET_ISSUING_STATE_QUERY } from "./gql";

const AgreementBox = ({ type, label, checked, handleChange }) => {
  return (
    <div
      key={type}
      className="flex flex-col items-start space-y-4 my-4 bg-white p-6 shadow rounded"
    >
      <LegalLink
        className="font-bold hover:font-bold hover:text-green-primary"
        type={type}
      />
      <Checkbox label={label} checked={checked} onChange={handleChange} />
    </div>
  );
};

const IssuingCardholderAgreement = ({ restartPolling }) => {
  const [esignAccepted, setEsignAccepted] = useState(false);
  const [userTermsAccepted, setUserTermsAccepted] = useState(false);
  const [submitTermsAccepted] = useMutation(SUBMIT_CARDHOLDER_TERMS_QUERY);
  const [loading, setLoading] = useState(false);
  const [transitioning, setTransitioning] = useState(false);
  const [error, setError] = useState(null);

  const submitTermsHandler = () => {
    setLoading(true);
    submitTermsAccepted({
      refetchQueries: [
        {
          query: GET_ISSUING_STATE_QUERY,
        },
      ],
    })
      .then(() => {
        setTransitioning(true);
        restartPolling();
      })
      .catch(() => {
        setError("Something went wrong, please try again.");
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const agreements = [
    {
      type: LEGAL_LINK_TYPES.ISSUING_ESIGN,
      label: `I have read and accept the
      ${LEGAL_LINK_CONFIG.ISSUING_ESIGN.text}`,
      checked: esignAccepted,
      handleChange: (e) => setEsignAccepted?.(e.target.checked),
    },
    {
      type: LEGAL_LINK_TYPES.ISSUING_AUTHORIZED_USER_TERMS,
      label: `I have read and accept the 
      ${LEGAL_LINK_CONFIG.ISSUING_AUTHORIZED_USER_TERMS.text}`,
      checked: userTermsAccepted,
      handleChange: (e) => setUserTermsAccepted?.(e.target.checked),
    },
  ];

  return (
    <div className="flex flex-col items-center justify-center text-center">
      <div className="text-3xl">Action Required</div>

      <div className="mt-4 text-xl">
        <span>You must accept the cardholder agreements to continue.</span>
      </div>
      <div className="mt-6">
        <div className="flex flex-col items-start text-left bg-gray-200 p-4 pb-6 rounded shadow-md">
          <p className="italic">
            Please review and accept the following agreements:
          </p>

          <div className="flex flex-col space-y-2">
            {agreements.map((a) => AgreementBox(a))}
          </div>
        </div>
        <div>
          {!!error && <div className="mt-4 text-red-500">{error}</div>}
          <div className="mt-6">
            <Button
              disabled={!esignAccepted || !userTermsAccepted || loading || transitioning}
              onClick={submitTermsHandler}
            >
              {loading ? "Continuing" : "Continue"}
              {loading && (
                <i className="ml-2 fa-solid fa-circle-notch fa-spin text-white" />
              )}
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default IssuingCardholderAgreement;
